const o = console.error, n = console.warn, r = console.info;
export {
  o as originalConsoleError,
  r as originalConsoleInfo,
  n as originalConsoleWarn
};
